const roles = [
  { icon: 'ri-team-line', title: 'С сотрудниками', desc: 'Задачи, ответственность, результаты, сроки, мотивация и изменение поведения.' },
  { icon: 'ri-star-smile-line', title: 'С сильными специалистами', desc: 'Когда у сотрудника высокая ценность для компании и руководителю нужно одновременно сохранять требования и отношения.' },
  { icon: 'ri-user-settings-line', title: 'С другими руководителями', desc: 'Ресурсы, приоритеты, ответственность, сроки и интересы подразделений.' },
  { icon: 'ri-vip-crown-line', title: 'С собственником', desc: 'Результаты, ресурсы, бюджет, стратегия, ответственность и аргументация управленческих решений.' },
  { icon: 'ri-building-2-line', title: 'С вышестоящим руководством', desc: 'Защита позиции, аргументация решений, обсуждение результатов и ожиданий.' },
  { icon: 'ri-shake-hands-line', title: 'С клиентами', desc: 'Ключевые сделки, сложные условия, претензии, цена и ценность.' },
  { icon: 'ri-organization-chart', title: 'С партнёрами', desc: 'Условия сотрудничества, ответственность, ресурсы и взаимные обязательства.' },
];

export default function NegotiationRoles() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-3">
          С кем руководителю приходится договариваться
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-12 max-w-3xl mx-auto leading-relaxed">
          Основные переговорные роли руководителя — от ежедневных разговоров с командой до стратегических переговоров с собственником
        </p>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {roles.map((r) => (
            <div key={r.title} className="bg-white rounded-xl border border-gray-200 p-5 md:p-6 hover:border-teal-300 transition-colors">
              <div className="w-10 h-10 rounded-full bg-teal-100 flex items-center justify-center mb-4">
                <i className={`${r.icon} text-teal-700 text-lg`}></i>
              </div>
              <h3 className="font-bold text-gray-900 text-sm mb-2">{r.title}</h3>
              <p className="text-gray-600 text-xs leading-relaxed">{r.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}